<template>
    <div class="share">
        <div class="wrapper">
            <Header title="每日分享" :show-back="true" color="white">
                <div slot="right">
                    <img
                            src="../../assets/img/share/menu_icon.png"
                            @click="$router.push({path:'/shareList'})"
                    />
                </div>
            </Header>
            <div class="signIn">
                <div class="signIn-label">
                    <dl class="left">
                        连续签到
                        <span class="highlight">1</span>天
                        <img class="signIn-rect" src="../../assets/img/share/signIn_rect.png"/>
                    </dl>
                    <dl class="right">

                        <span>任务提醒</span>
                        <img :class="{isRemind:'isChecked'}"
                             :src="require(isRemind ? '../../assets/img/share/radio_checked.png': '../../assets/img/share/radio.png')"
                             @click="onRemind"/>
                    </dl>
                </div>
                <div class="signIn-day">
                    <dl class="signIn-day-item" v-for="item in checkedList" :key="item.sign_num" @click="onSign">
                        <dd :class="{ 'gold': !item.is_sign, 'circular': true }">
                            <span>{{item.num}}XMI</span>
                            <div class="checked" v-if="item.is_sign">
                                <img src="../../assets/img/share/checked.png"/>
                            </div>
                            <!-- <span class="gold-add">+20</span> -->
                        </dd>
                        <dd class="text">{{item.sign_num}}天</dd>
                    </dl>
                </div>
            </div>
        </div>
        <div class="content">
            <van-cell
                    class="cell"
                    title-class="cell-title"
                    label-class="cell-label"
                    title="每日分享分享专属海报"
                    label="每日完成分享可获得XMI奖励"
                    is-link
                    to="/shareImg"
            >
                <img class="cell-left" slot="icon" src="../../assets/img/share/share_icon.png"/>

                <img class="cell-right" slot="right-icon" src="../../assets/img/share/right.png"/>
            </van-cell>
            <van-cell
                    class="cell"
                    title-class="cell-title"
                    label-class="cell-label"
                    title="上传图片"
                    label="上传朋友圈截图即可获得奖励"
                    is-link
                    to="/uploadImage"
            >
                <img class="cell-left" slot="icon" src="../../assets/img/share/image_icon.png"/>

                <img class="cell-right" slot="right-icon" src="../../assets/img/share/right.png"/>
            </van-cell>
            <div class="rules">
                <div class="rules-title">
                    <img src="../../assets/img/share/warn.png"/>
                    <span>分享规则</span>
                </div>
                <dl class="text">1、<p>每日截图海报分享至朋友圈。</p></dl>
                <dl class="text">
                    2、<p>分享至朋友圈24小时后上传图片审核通过即可获得XMI奖励。</p>
                </dl>
                <dl class="text">3、<p></p>.连续签到奖励会越来越丰厚，如中途没有连续签到则奖励重置回第一天。</dl>
            </div>
            <div class="rules">
                <div class="rules-title">
                    <img src="../../assets/img/share/warn.png"/>
                    <span>分享规则</span>
                </div>
                <div class="rules-tips">
                    <p>
                        <span class="left">第一天：奖励5个XMI</span>
                        <span>第二天：奖励6个XMI</span>
                    </p>
                    <p>
                        <span class="left">第三天：奖励7个XMI</span>
                        <span>第四天：奖励8个XMI</span>
                    </p>
                    <p>
                        <span class="left">第五天：奖励9个XMI</span>
                        <span>第六天：奖励10个XMI</span>
                    </p>
                    <p>
                        <span class="left">第七天：奖励12.5个XMI</span>
                        <span class="left">第八天：奖励12.5个XMI</span>
                    </p>
                    <p>
                        <span class="left">第九天：奖励12.5个XMI</span>
                        <span class="left">第十天：奖励12.5个XMI</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from "../../components/header";

    export default {
        components: {
            Header
        },
        data() {
            return {
                currency: "USDT",
                checkedList: [],//签到列表,
                isRemind: false
            };
        },
        created() {
            this.getData()
        },
        methods: {
            getData() {
                this.ajax.post('appapi/user/signInfo').then((res) => {
                    if (res.data.code === 1) {
                        console.log(res.data.data)
                        this.checkedList = res.data.data
                    }
                })
            },
            //签到
            onSign() {
                this.ajax.post('appapi/user/sign').then((res) => {
                    if (res.data.code === 1) {
                        console.log(res.data.data)
                        this.$toast(res.data.msg || '设置成功')
                        this.getData()
                    }
                })
            },
            onRemind() {
                this.isRemind = !this.isRemind
                this.ajax.post('appapi/user/setSignStatus', {
                    status: this.isRemind ? 0 : 2
                }).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg || '设置成功')
                    }
                })
            }
        }

    }
</script>

<style lang="scss">
    .share {
        background: #fefefe;

        .wrapper {
            background: url(../../assets/img/background2.png) no-repeat 0 0;
            background-size: 100%;
            width: 100%;
            padding: 60px 0 0;
        }

        .content {
            padding: 0 30px 50px;
        }

        .signIn {
            margin: 30px;
            height: 249px;
            padding: 27px 35px 30px;
            box-sizing: border-box;
            background: #fff;
            box-shadow: 0px 10px 29px 0px rgba(226, 226, 226, 0.4);
            border-radius: 20px;

            &-label {
                @include flex($main: space-between);
                color: #4f5668;
                margin-bottom: 32px;

                .left {
                    position: relative;
                    padding: 0 0 0 8px;
                    font-size: 28px;
                    height: 50px;

                    img {
                        position: absolute;
                        width: 142px;
                        height: 24px;
                        top: 20px;
                        left: 0;
                    }

                    .highlight {
                        color: #3ca167;
                    }
                }

                .right {
                    @include flex($cross: center);
                    font-size: 24px;
                    // line-height: 25px;
                    img {
                        width: 62px;
                        height: 30px;
                        margin-left: 12px;

                        &.isChecked {
                            width: 70px;
                            height: 41px;
                        }
                    }
                }
            }

            &-day {
                @include flex();

                &-item {
                    text-align: center;
                    font-size: 9px;
                    flex: 1;
                }

                .circular {
                    width: 84px;
                    height: 84px;
                    display: inline-block;
                    background: rgba(235, 246, 240, 1);
                    border-radius: 50%;
                    margin-bottom: 10px;
                    color: #0ec15e;
                    line-height: 68px;
                    position: relative;
                    padding-top: 8px;

                    span {

                        line-height: 27px;
                    }

                    .checked {
                        position: absolute;
                        width: 20px;
                        height: 20px;
                        right: 5px;
                        bottom: 20px;
                    }

                    &.gold {
                        background: url(../../assets/img/share/gold.png) no-repeat 0 0;
                        background-size: 100%;
                        color: #fff;
                        line-height: 42px;

                        .gold-add {
                            display: inline-block;
                            position: absolute;
                            width: 39px;
                            height: 22px;
                            top: -10px;
                            right: -10px;
                            line-height: 23px;
                            background: url(../../assets/img/share/add_rect.png) no-repeat 0 0;
                            background-size: 100%;
                        }
                    }
                }

                .text {
                    color: #10914a;
                    font-size: 23px;
                    line-height: 38px;
                }
            }
        }

        .cell {
            align-items: center;
            margin-bottom: 30px;
            height: 157px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 10px 29px 0px rgba(226, 226, 226, 0.4);
            border-radius: 20px;
            padding: 37px 37px 37px 55px;

            &-title {
                font-size: 28px;
                color: #4f5668;
            }

            &-label {
                font-size: 20px;
                color: #b9c4d3;
            }

            &-left {
                width: 83px;
                height: 83px;
                margin-right: 26px;
            }

            &-right {
                width: 22px;
                height: 22px;
            }
        }

        .rules {
            margin-top: 30px;
            padding: 0 30px 45px;
            background: #f9f9f9;
            color: #777777;
            font-size: 24px;
            border-radius: 10px;

            &-title {
                font-size: 26px;
                padding: 30px 0;

                img {
                    width: 28px;
                    height: 24px;
                    margin-right: 11px;
                }
            }

            .text {
                display: flex;
            }

            p {
                line-height: 28px;
                margin-bottom: 30px;
            }

            &-tips {
                .left {
                    margin-right: 54px;
                }
            }
        }
    }
</style>
